import styled, { css } from "styled-components";

export const PageCover = styled.div`
    justify-content: center;
    align-items: center;
    display: grid;
    height: 100vh;
`;

export const BoxInfo = styled.div`
    align-items: center;
    place-content: center;
    justify-content: center;
    width: 400px;
    padding: 20px;
    border: 1px solid black;

    div{
        margin: 10px;
    }
`;

export const CenterContainer = styled.div`
    align-items: center;
    place-content: center;
    justify-content: center;
    height: 300px;
    width: 400px;
    padding: 10px;
    text-align: center;

    img{
        margin-bottom: 2px; 
        height: 60px; 
        max-width: 300px;
    }
`;

export const BlockContainer = styled.div`
    padding: 10px;
    width: 100%;
`;

export const BlueSpan = styled.span`
    color: var(--blue) !important
`;

export const PrintStyles = css`
    .cover{
        display: none !important;
    } 
    .onlyPrintElement{
        display: none;
    }
    @media print{
        @page {
            margin: 20px;
            body{
                background-color: #FFF;
                color: #474555 !important;
            }
        }
        .noPrintElement{
            display: none !important;
        }

        .onlyPrintElement{
            display: flex;
        }

        img{
            margin-bottom: 2px; 
            height: 60px; 
            max-width: 300px;
        }
    }
`;


export const paginationsStlyes = {
	ulContainer: css`
        @media print{
            overflow:unset; 
            >div{
                min-height:unset;
                max-height:unset;
                background: var(--greysofter);
            }
        }`,
	row: css`
        @media print{
            flex-direction: row !important;
            background-color: var(--greysofter);
            color: var(--black);
            font-size: 8px;
            background-color: var(--greysofter);

            &:nth-child(odd){
                background-color: var(--greysofter);   
            }
        }`,
	header: css`
        flex-wrap: wrap;
        >div:first-child{
                padding-left:5px ;
            } 
        @media print{
            flex-direction: row !important;
            color: var(--black);
            font-size: 10px;
        }`
};

export default BlockContainer;
